import React from 'react'
import PropTypes from 'prop-types'
import style from './Flag.less'

const Flag = (props) => <i className={style[props.countryCode]}></i>

Flag.propTypes = {
  countryCode: PropTypes.string.isRequired,
}

export default Flag
